import type {
  ShopifyStaffStore,
  ShopifyStaffStoreAction,
  ShopifyStaffStoreActionResult,
} from '@discovr/types';
import { getPaged, pagedQs, postData, type PagedRows } from './shared';

const STORES_BASE = '/admin/shopify/stores';

const listStores = (page: number, limit: number): Promise<PagedRows<ShopifyStaffStore>> =>
  getPaged<ShopifyStaffStore>(`${STORES_BASE}?${pagedQs({ page, limit })}`);

const runAction = (
  shop: string,
  action: ShopifyStaffStoreAction,
): Promise<ShopifyStaffStoreActionResult> =>
  postData<ShopifyStaffStoreActionResult>(`${STORES_BASE}/${encodeURIComponent(shop)}/${action}`);

export const createShopifyStaffStoresApi = () => ({ listStores, runAction });

export type ShopifyStaffStoresApi = ReturnType<typeof createShopifyStaffStoresApi>;
